// https://vuex.vuejs.org/en/getters.html

export default {
  baseUrl (state) {
    return state.baseUrl
  },

  cancelTokens (state) {
    return state.cancelTokens
  },

  isCashRegisterInstalled (state) {
    return state.identifier !== null
  },

  isCashRegisterConfigured (state) {
    return state.identifier !== null && state.printer !== null
  },

  isPrinterConfigured (state) {
    return state.printer !== null && state.printer !== ''
  },

  cashRegister (state) {
    return state.cashRegister
  },

  store (state) {
    return state.cashRegister ? state.cashRegister.store : null
  },

  locale (state) {
    return state.i18n.locale
  },

  locales (state) {
    return Object.keys(state.i18n.translations)
  },

  products (state) {
    // do some sorting
    return state.products
  },

  catalogSize (state) {
    return state.products.length
  }
}
